import { DateTime } from "luxon";

export const daysInYear = () => {
    const year = DateTime.now().toFormat("yyyy");
    return (year % 4 === 0 && year % 100 > 0) || year % 400 === 0 ? 366 : 365;
};